module.exports = __webpack_public_path__ + "static/img/gold.292034d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ranks/gold.png
// module id = R3Rf
// module chunks = 1